export type ViewportXY = { x: number; y: number; zoom: number };

/** `Viewport.x`/`y` are already screen pixels, so the delta is not scaled by zoom. */
export function panViewport(viewport: ViewportXY, dx: number, dy: number): ViewportXY {
  return { ...viewport, x: viewport.x + dx, y: viewport.y + dy };
}

export type FocusInfo = {
  tagName?: string;
  isContentEditable?: boolean;
};

export function shouldActivatePan(code: string, focus: FocusInfo | null): boolean {
  if (code !== "Space") return false;
  if (!focus) return true;
  if (focus.isContentEditable) return false;
  const tag = (focus.tagName ?? "").toUpperCase();
  return tag !== "BUTTON" && tag !== "INPUT" && tag !== "TEXTAREA" && tag !== "SELECT";
}
